module.exports = __webpack_public_path__ + "static/SailingSim-7d23bb25d266a0036a52c82e5d9ce8a6.gif";